import {useEffect, useRef, useCallback} from 'react';
import Link from 'next/link';

import {pageUrl} from '@utils/product';
import ShortDescription from '@components/product/detail/ShortDescription';

import {useCategory} from './Context/Category';

function Breadcrumbs(props) {
	const {styles} = props;
	const {breadcrumbs} = useCategory();
	const descriptionRef = useRef({});
	const info = breadcrumbs.length ? breadcrumbs[breadcrumbs.length - 1] : null;

	const updateCss = useCallback((item, color) => {
		for (let c of item) {
			c.style.color = color;
			if (c.children) updateCss(c.children, color);
		}
	}, []);

	useEffect(() => {
		if (info?.description?.text && descriptionRef?.current?.lastChild) {
			updateCss(descriptionRef.current.children, info.description.color);
		}
	}, [info?.description, updateCss]);

	return (
		<>
			<ul
				className={`breadcums ${styles.breadcums} d-flex align-items-center justify-content-center`}
			>
				{!!(props.store || props.brand || breadcrumbs.length) && (
					<li>
						<Link href='/'>Home</Link>
					</li>
				)}

				{props.isAuction && (
					<>
						<li>
							<Link href='/'>Home</Link>
						</li>
						<li>
							<Link href='/drop-auctions/all'>All Auctions</Link>
						</li>
					</>
				)}
				{props.store && (
					<>
						<li>
							<Link href='/all-stores'>All Stores</Link>
						</li>
						<li>
							{breadcrumbs.length ? (
								<Link href={`/stores/${props.store}`}>{props.storeName}</Link>
							) : (
								<span>{props.storeName}</span>
							)}
						</li>
					</>
				)}

				{props.brand && (
					<>
						<li>
							{breadcrumbs.length ? (
								<Link href={`/brands/${breadcrumbs[0].slug}`}>All Brands</Link>
							) : (
								<Link href={`/brands/women`}>All Brands</Link>
							)}
						</li>
						<li className='noslug textCapitalize'>
							{breadcrumbs.length ? (
								<Link href={pageUrl(props)}>{props.brandName}</Link>
							) : (
								<span>{props.brandName}</span>
							)}
						</li>
					</>
				)}

				{breadcrumbs.map((item, index) => {
					if (index === breadcrumbs.length - 1) {
						return <li key={item._id}>{item.Name}</li>;
					} else {
						return (
							<li key={item._id}>
								<Link href={pageUrl(props, item.slug)}>{item.Name}</Link>
							</li>
						);
					}
				})}
			</ul>
			{info && (
				<div className={`${styles.pageHeading}`}>
					<h1>{info.Name} </h1>
					{info.description &&
						info.description.status &&
						info.description.text && (
							<ShortDescription
								descriptionRef={descriptionRef}
								heightVal={20}
								text={info.description.text}
							/>
						)}
				</div>
			)}
		</>
	);
}

export default Breadcrumbs;
